import { Pipe, PipeTransform } from 'angular-ts-decorators';

import { IImageRoot } from '@shared/app/scripts/services/image-root';
import { SettingsManager } from '@shared/app/scripts/services/settings-manager';

export type ProductImageFilter = (
  articleCode: string,
  size: ProductImageSize,
) => any;

interface IProductImage {
  transform: ProductImageFilter;
}

export type ProductImageSize = 'thumbnail' | 'small' | 'medium' | 'large';

/**
 * Changes input article code into a product image url
 *
 * # Usage
 * `{{ $ctrl.articleCode | productImage: 'small' }}`
 *
 * # Note
 * It replace (and overlaps) with {@link wholesaleModule.filter:productImage}.
 * @param {string} articleCode articleCode of product to be displayed
 * @param {ProductImageSize}  size image type
 * @return {string} image url
 */
@Pipe({ name: 'productImage' })
export class ProductImagePipe implements PipeTransform, IProductImage {
  constructor(
    private settingsManager: SettingsManager,
    private urlEscapeFilter,
    private imageRoot: IImageRoot,
  ) {
    'ngInject';
  }

  public transform(articleCode: string, size: ProductImageSize): string {
    let sizePath = '';
    let image = '';
    let path = '';
    let urlRoot = this.settingsManager.settings.imageRoot
      ? this.settingsManager.settings.imageRoot
      : this.imageRoot();

    if (size === 'thumbnail') {
      sizePath = 'sizet';
    } else if (size === 'small') {
      sizePath = 'size0';
    } else if (size === 'medium') {
      sizePath = 'size1';
    } else if (!size || size === 'large') {
      sizePath = 'size2';
    }

    if (articleCode) {
      image = `${this.urlEscapeFilter(articleCode)}.jpg`;
    } else {
      image = 'undefined.jpg';
    }

    if (this.settingsManager.settings.imageRoot) {
      path = `images/${sizePath}/`;
    } else {
      // Use Softwear's standard path
      path = `${this.settingsManager.settings.uploadDirectory}/images/${sizePath}/`;
    }

    // Example: https://cdn.softwearconnect.com/123457890/images/size2/product-1234.JPG
    return `${urlRoot}/${path}${image}`;
  }
}
